import React, { useEffect } from 'react';
import { BrowserRouter, HashRouter, useLocation } from 'react-router-dom';
import { isSubdomain } from 'helpers';
import { baseRoute, appEnvironment } from 'helpers/constants';

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

/**
 * Router determined based on environment.
 * Basename *not* appended to router if a subdomain login is used
 */
export const Router: React.FC = (props) => {
  const DynamicRouter: React.ReactType = appEnvironment === 'chrome' ? HashRouter : BrowserRouter;

  if (isSubdomain()) {
    return (
      <DynamicRouter>
        <ScrollToTop />
        {props.children}
      </DynamicRouter>
    );
  } else {
    return (
      <DynamicRouter basename={baseRoute}>
        <ScrollToTop />
        {props.children}
      </DynamicRouter>
    );
  }
};
